var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFleetcore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    role: "img",
    "aria-label": "FleetCore",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7h17v16H3V7Zm17 6h5l4 5v5h-9V13Z",
    fill: "none",
    stroke: "#168AD6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 25,
    r: 3,
    fill: "#F8FBFF",
    stroke: "#168AD6",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 3,
    fill: "#F8FBFF",
    stroke: "#168AD6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFleetcore);
export default __webpack_public_path__ + "static/media/icon-fleetcore.0c5fff185385d0991fdf7782da8067d4.svg";
export { ForwardRef as ReactComponent };